import React from "react";
import { connect } from 'react-redux';

import './themes.css';

const setChartColor = (lastWeek,thisWeek) => {
    return {
        type:'setChartColor',
        lastWeekColor: lastWeek,
        thisWeekColor: thisWeek
    }
}

const mapStateToProps = (state) => {
    return {
        lastWeekColor: state.lastWeekColor,
        thisWeekColor: state.thisWeekColor
    }
}

const mapDispatchToProps = { setChartColor }

function hexToRgb(hex){
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

    return result ? parseInt(result[1], 16)+","+parseInt(result[2], 16)+","+parseInt(result[3], 16) : null;
}



function Theme(props){
    const themes = require('./themes.json');

    let theme_details = themes.find(choice => choice.theme === props.theme);
    let body_bg = theme_details.body_bg;
    let primary = theme_details.primary;
    let primary_text = theme_details.primary_text;
    let secondary = theme_details.secondary;
    let secondary_text = theme_details.secondary_text;
    let success = theme_details.success;
    let success_text = theme_details.success_text;
    let info = theme_details.info;
    let warning = theme_details.warning;
    let danger = theme_details.danger;
    let light = theme_details.light;
    let dark = theme_details.dark;
    

    let primary_rgb = hexToRgb(theme_details.primary);
    let secondary_rgb = hexToRgb(theme_details.secondary);
    let success_rgb = hexToRgb(theme_details.success);
    let info_rgb = hexToRgb(theme_details.info);
    let warning_rgb = hexToRgb(theme_details.warning);
    let danger_rgb = hexToRgb(theme_details.danger);
    let light_rgb = hexToRgb(theme_details.light);
    let dark_rgb = hexToRgb(theme_details.dark);
    props.setChartColor(secondary,theme_details.thisWeek);

    return (
        <style type='text/css'>
            :root {`{`}
                --bs-body-bg:{body_bg};
                --bs-primary:{primary};
                --bs-primary-text:{primary_text};
                --bs-secondary:{secondary};
                --bs-secondary-text:{secondary_text};
                --bs-success:{success};
                --bs-success-text:{success_text};
                --bs-info:{info};
                --bs-warning:{warning};
                --bs-danger:{danger};
                --bs-light:{light};
                --bs-dark:{dark};
                --bs-primary-rgb:{primary_rgb};
                --bs-secondary-rgb:{secondary_rgb};
                --bs-success-rgb:{success_rgb};
                --bs-info-rgb:{info_rgb};
                --bs-warning-rgb:{warning_rgb};
                --bs-danger-rgb:{danger_rgb};
                --bs-light-rgb:{light_rgb};
                --bs-dark-rgb:{dark_rgb};
                {`}`}
        </style>
        );
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Theme);
